import type {
  Control_Bool_Exp,
  GetControlCountQuery,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetControlCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type ControlCountArgs = {
  // Resolved entity-filter selection — drives the tRPC path. Empty/absent ⇒
  // no entity filter.
  entityIds?: string[];
  // The equivalent Hasura bool_exp — drives the GraphQL fallback so the
  // flag-gated twin counts identically. Built by useEntityWhereFilter.
  where?: Control_Bool_Exp;
};

export const useGetControlCount = createQueryHook<
  ControlCountArgs,
  number,
  GetControlCountQuery
>({
  trpcQueryOptions: (trpc, queryArgs) =>
    trpc.frontend.control.controlCount.queryOptions({
      entityIds: queryArgs?.entityIds,
    }),
  // Pass the count straight through (not `data ?? 0`): the factory surfaces
  // undefined while loading, so a genuine 0 must stay 0.
  mapTrpcDataToGraphQL: (data) => ({
    control_aggregate: {
      aggregate: {
        count: data,
      },
    },
  }),
  graphqlDocument: GetControlCountDocument,
  graphqlVariables: (queryArgs) => ({ where: queryArgs?.where }),
});
